import { ApplicationsInfoServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/applications_info/Applications_infoServiceClientPb';
import {
  ApplicationPlatformsInfo,
  GetPlatformsInfoRequest,
  GetPlatformsInfoResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/applications_info/applications_info_pb';

export type ApplicationsInfoExportClasses = {
  ApplicationsInfoServiceClient: typeof ApplicationsInfoServiceClient;
  ApplicationPlatformsInfo: typeof ApplicationPlatformsInfo;
  GetPlatformsInfoRequest: typeof GetPlatformsInfoRequest;
  GetPlatformsInfoResponse: typeof GetPlatformsInfoResponse;
};

export const applicationsInfo: ApplicationsInfoExportClasses = {
  ApplicationsInfoServiceClient,
  ApplicationPlatformsInfo,
  GetPlatformsInfoRequest,
  GetPlatformsInfoResponse,
};
